import { Component } from "@angular/core";
import { FormBuilder, Validators, ValidatorFn, FormGroup, ValidationErrors, AbstractControl, FormControl } from "@angular/forms";
import { MainService } from "src/app/Services/service.service";
import { Router } from "@angular/router";
import { MatDialogRef } from "@angular/material";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.css"]
})
export class RegisterComponent {

  public enablePhoneRegConfirm:boolean = false;

  registrationForm = this.fb.group(
    {
      email: [null, Validators.compose([Validators.required, Validators.email])],
      password: [null, Validators.compose([Validators.required, Validators.minLength(5)])],
      passwordConfirm: [null, Validators.compose([Validators.required, confirmPasswordValidator()])],
      phone: [null, Validators.required],
      igreeDisclaimer: [false, Validators.requiredTrue]
    },
    { validators: registrationFormValidate }

    
  );

  

  states = [
    { name: "Alabama", abbreviation: "AL" },
    { name: "Alaska", abbreviation: "AK" },
    { name: "American Samoa", abbreviation: "AS" },
    { name: "Arizona", abbreviation: "AZ" },
    { name: "Arkansas", abbreviation: "AR" },
    { name: "California", abbreviation: "CA" },
    { name: "Colorado", abbreviation: "CO" },
    { name: "Connecticut", abbreviation: "CT" },
    { name: "Delaware", abbreviation: "DE" },
    { name: "District Of Columbia", abbreviation: "DC" },
    { name: "Federated States Of Micronesia", abbreviation: "FM" },
    { name: "Florida", abbreviation: "FL" },
    { name: "Georgia", abbreviation: "GA" },
    { name: "Guam", abbreviation: "GU" },
    { name: "Hawaii", abbreviation: "HI" },
    { name: "Idaho", abbreviation: "ID" },
    { name: "Illinois", abbreviation: "IL" },
    { name: "Indiana", abbreviation: "IN" },
    { name: "Iowa", abbreviation: "IA" },
    { name: "Kansas", abbreviation: "KS" },
    { name: "Kentucky", abbreviation: "KY" },
    { name: "Louisiana", abbreviation: "LA" },
    { name: "Maine", abbreviation: "ME" },
    { name: "Marshall Islands", abbreviation: "MH" },
    { name: "Maryland", abbreviation: "MD" },
    { name: "Massachusetts", abbreviation: "MA" },
    { name: "Michigan", abbreviation: "MI" },
    { name: "Minnesota", abbreviation: "MN" },
    { name: "Mississippi", abbreviation: "MS" },
    { name: "Missouri", abbreviation: "MO" },
    { name: "Montana", abbreviation: "MT" },
    { name: "Nebraska", abbreviation: "NE" },
    { name: "Nevada", abbreviation: "NV" },
    { name: "New Hampshire", abbreviation: "NH" },
    { name: "New Jersey", abbreviation: "NJ" },
    { name: "New Mexico", abbreviation: "NM" },
    { name: "New York", abbreviation: "NY" },
    { name: "North Carolina", abbreviation: "NC" },
    { name: "North Dakota", abbreviation: "ND" },
    { name: "Northern Mariana Islands", abbreviation: "MP" },
    { name: "Ohio", abbreviation: "OH" },
    { name: "Oklahoma", abbreviation: "OK" },
    { name: "Oregon", abbreviation: "OR" },
    { name: "Palau", abbreviation: "PW" },
    { name: "Pennsylvania", abbreviation: "PA" },
    { name: "Puerto Rico", abbreviation: "PR" },
    { name: "Rhode Island", abbreviation: "RI" },
    { name: "South Carolina", abbreviation: "SC" },
    { name: "South Dakota", abbreviation: "SD" },
    { name: "Tennessee", abbreviation: "TN" },
    { name: "Texas", abbreviation: "TX" },
    { name: "Utah", abbreviation: "UT" },
    { name: "Vermont", abbreviation: "VT" },
    { name: "Virgin Islands", abbreviation: "VI" },
    { name: "Virginia", abbreviation: "VA" },
    { name: "Washington", abbreviation: "WA" },
    { name: "West Virginia", abbreviation: "WV" },
    { name: "Wisconsin", abbreviation: "WI" },
    { name: "Wyoming", abbreviation: "WY" }
  ];

  public loading: boolean = false;

  constructor(private fb: FormBuilder, 
    public services: MainService,
    public dialogRef: MatDialogRef<RegisterComponent>
    ) { 

    this.enablePhoneRegConfirm = services.enablePhoneRegConfirm;


    this.registrationForm.controls["igreeDisclaimer"].setValue(false);
  
  }

  private _captchaResolvedFlag = false;

  getCaptchaResolvedFlag(): boolean {
    return this._captchaResolvedFlag;
  }

  setCaptchaResolvedFlag(value) {
    this._captchaResolvedFlag = value;
  }

  captchaResolved(captchaResponse: string) {
    this.setCaptchaResolvedFlag(true)
  }

  captchaAvailable() {
    return this.services.captchaService.getCurrentCaptchaKey() != "";
  }

  isCaptchaOk(): boolean {
    return this.captchaAvailable() && this._captchaResolvedFlag;
  }

  isEmailNotValid() {
    return this.registrationForm.controls["email"].hasError("required") || this.registrationForm.controls["email"].hasError("email");
  }

  getEmailErrorMessage() {
    return this.registrationForm.controls["email"].hasError("required") ? "Email is required" : this.registrationForm.controls["email"].hasError("email") ? "Enter valid email address" : "";
  }

  isPasswordNotValid() {
    return this.registrationForm.controls["password"].hasError("required") || this.registrationForm.controls["password"].hasError("minlength") || this.registrationForm.hasError("passwordConfirmed");
  }

  getPasswordErrorMessage() {
    return this.registrationForm.controls["password"].hasError("required")
      ? "Password is required"
      : this.registrationForm.controls["password"].hasError("minlength")
        ? "Password must have at 5 chars length."
        : this.registrationForm.hasError("passwordConfirmed")
          ? "Password and Confirmation must be equal."
          : "";
  }

  isPasswordConfirmNotValid() {
    return (
      this.registrationForm.controls["passwordConfirm"].hasError("required") || this.registrationForm.controls["passwordConfirm"].value != this.registrationForm.controls["passwordConfirm"].value || this.registrationForm.hasError("passwordConfirmed")
    );
  }

  getPasswordConfirmErrorMessage() {
    return this.registrationForm.controls["passwordConfirm"].hasError("required") ? "Password Confirmation is required" : this.registrationForm.hasError("passwordConfirmed") ? "Password and Confirmation must be equal." : "";
  }

  public afterRegClose:boolean = false
  onSubmit() {
    this.validateAllFormFields(this.registrationForm);
    if (!this.registrationForm.invalid) {
      if (!this.isCaptchaOk()) {
        this.services.showError("Please confirm the captcha");
      }else{
        this.loading = true;
        this.services.userService
          .register(this.registrationForm.controls["email"].value, this.registrationForm.controls["phone"].value, this.registrationForm.controls["password"].value, this.registrationForm.controls["passwordConfirm"].value, "registration-success")
          .then(r => {
            this.services.route.navigate([r]);
            this.afterRegClose = true;
            this.dialogRef.close();
            this.loading = false;
          })
          .catch(e => {
            this.loading = false;
            this.services.showError(e);
          });
        }
    }
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  public formControlIsValid(formGroup, formCtrl) : boolean {
    if (formGroup.controls.hasOwnProperty(formCtrl)) {
      if (!formGroup.controls[formCtrl].touched) return true;
      return formGroup.controls[formCtrl].valid;
    }
    return false;
  }

}

export function confirmPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    var p = control.parent ? control.parent.controls["password"].value : "";
    var pc = control.parent ? control.parent.controls["passwordConfirm"].value : "";
    return p != pc ? { passwordConfirm: { value: control.value } } : null;
  };
}

export const registrationFormValidate: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const p = control.get("password");
  const pc = control.get("passwordConfirm");
  let res = p && pc && pc.value === p.value ? null : { passwordConfirmed: true };
  return res;
};
